// Declare global variables
let referenceHandle;
let testLimitsData;

document.addEventListener("DOMContentLoaded", function() {
  loadReferenceProduct();
  window.addEventListener("resize", displayCorrectTableVersion); // Toggle tables on resize
});

async function loadReferenceProduct() {
  try {
    const handleElement = document.getElementById("product-handle");
    if (!handleElement) {
      console.error("Elemento 'product-handle' non trovato");
      hideReferenceTableSections();
      return;
    }

    const handle = handleElement.getAttribute("data-handle");

    // 1. Recupera l'handle del prodotto di riferimento da `custom.testlimits_reference`
    referenceHandle = await fetchReferenceHandle(handle);
    if (!referenceHandle) {
      console.error("Errore: riferimento non trovato.");
      hideReferenceTableSections();
      return;
    }

    // 2. Recupera i dati `custom.testlimiti` del prodotto referenziato
    testLimitsData = await fetchTestLimitsData(referenceHandle);
    if (!testLimitsData) {
      console.error("Errore: dati del prodotto non trovati.");
      hideReferenceTableSections();
      return;
    }

    // 3. Renderizza la tabella con la struttura richiesta
    if (window.innerWidth <= 768) {
      console.log("Rendering mobile table");
      renderReferenceTableMobile(testLimitsData, "reference-table-container-mobile"); // Mobile
      attachFilterEventListenersMobile(); // Attach mobile filter event listeners
    } else {
      console.log("Rendering desktop table");
      renderReferenceTable(testLimitsData, "reference-table-container"); // Desktop
      attachFilterEventListeners(); // Attach desktop filter event listeners
    }

    // 4. Load availability after rendering the tables
    loadAvailability();

    // 5. Attach event listeners after rendering the tables
    attachAddToCartEventListeners();

  } catch (error) {
    console.error("Errore durante il caricamento del prodotto referenziato:", error);
    hideReferenceTableSections();
  }
}

// Display the correct table version based on screen width
async function displayCorrectTableVersion() {
  const desktopContainer = document.getElementById("variant-table-section-reference");
  const mobileContainer = document.getElementById("variant-table-section-reference-mobile");

  // Ensure testLimitsData is available
  if (!testLimitsData) {
    testLimitsData = await fetchTestLimitsData(referenceHandle);
    if (!testLimitsData) {
      console.error("Errore: dati del prodotto non trovati.");
      document.getElementById("reference-table-container").innerText = "Errore: dati del prodotto non trovati.";
      return;
    }
  }

    // Remove existing headings
    document.querySelectorAll('.dynamic-heading').forEach(el => el.remove());

    // Create a new heading element
    const heading = document.createElement('h2');
    heading.textContent = 'Varianti e versioni';
    heading.classList.add('dynamic-heading');

  if (window.innerWidth <= 1000) {
    renderReferenceTableMobile(testLimitsData, "reference-table-container-mobile"); // Mobile
    desktopContainer.style.display = "none";
    mobileContainer.style.display = "block";

    attachFilterEventListenersMobile(); // Attach mobile filter event listeners

  } else {
    renderReferenceTable(testLimitsData, "reference-table-container"); // Desktop
    desktopContainer.style.display = "block";
    mobileContainer.style.display = "none";

    attachFilterEventListeners(); // Attach desktop filter event listeners
  }
  

  // Load availability after re-rendering the tables
  loadAvailability();

  // Attach event listeners after rendering the tables
  attachAddToCartEventListeners();
}

// Function to load availability data and update the DOM
async function loadAvailability() {
  try {
    // Collect all handles from availability elements
    const availabilityElements = document.querySelectorAll('.availability-expanded[data-handle], .availability-main[data-handle], .availability-main-mobile[data-handle], .availability-mobile[data-handle]');
    const handles = Array.from(availabilityElements).map(el => el.getAttribute('data-handle'));
    const uniqueHandles = [...new Set(handles)];

    for (const handle of uniqueHandles) {
      // Fetch availability data for each handle
      const { available, quantity } = await fetchAvailabilityData(handle);

      // Update the availability elements in the DOM
      updateAvailabilityElements(handle, { available, quantity });
    }
  } catch (error) {
    console.error('Errore durante il caricamento delle disponibilità:', error);
  }
}

// Function to fetch availability data for a product handle
async function fetchAvailabilityData(handle) {
  try {
    const response = await fetch(`https://80d8cf-2.myshopify.com/api/2023-01/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '87660af8e936177d0da408b5058fb138'
      },
      body: JSON.stringify({
        query: `
          {
            productByHandle(handle: "${handle}") {
              variants(first: 1) {
                edges {
                  node {
                    availableForSale
                    quantityAvailable
                  }
                }
              }
            }
          }
        `
      })
    });

    const data = await response.json();
    const variant = data.data.productByHandle?.variants.edges[0]?.node;

    if (variant) {
      return {
        available: variant.availableForSale,
        quantity: variant.quantityAvailable
      };
    } else {
      return {
        available: false,
        quantity: 0
      };
    }
  } catch (error) {
    console.error('Errore durante il recupero dei dati di disponibilità:', error);
    return {
      available: false,
      quantity: 0
    };
  }
}

// Function to update all availability elements for a given handle
function updateAvailabilityElements(handle, { available, quantity }) {
  updateExpandedAvailability(handle, available, quantity); // Desktop expanded row
  updateDesktopMainRowAvailability(handle, available);     // Desktop main row
  updateMobileMainRowAvailability(handle, available);      // Mobile main row
  updateExpandedAvailabilityMobile(handle, available, quantity); // Mobile expanded row
}

    // Function to update availability in the desktop expanded row
    function updateExpandedAvailability(handle, available, quantity) {
    const expandedAvailabilityCell = document.querySelector(`.availability-expanded[data-handle="${handle}"]`);
    if (expandedAvailabilityCell) {
        expandedAvailabilityCell.innerHTML = `
        <div style="display: flex; align-items: center; margin-bottom: 10px;">
            <span style="display: flex; justify-content: center; align-items: center; width: 18px; height: 18px; background-color: ${available ? 'green' : 'red'}; border-radius: 50%; color: white; font-weight: bold; font-size: 10px; margin-right: 8px;">i</span>
            <span style="font-size: 12px;">${available ? quantity + ' Disponibili' : 'Non disponibile'}</span>
        </div>
        <div style="margin-top: 0px;">
            <span style="font-size: 12px; color: green; cursor: pointer;" onclick="openMail('${handle}')">
            Se desideri quantità superiori o particolari <u>clicca qui</u>
            </span>
        </div>
        `;
        console.log(`Disponibilità aggiornata per riga espansa handle ${handle}`);
    }
    }

    // Function to update availability in the desktop main row
    function updateDesktopMainRowAvailability(handle, available) {
    const mainAvailabilityCell = document.querySelector(`.availability-main[data-handle="${handle}"]`);
    if (mainAvailabilityCell) {
        mainAvailabilityCell.innerHTML = `
        <span style="display: flex; justify-content: center; align-items: center; width: 22px; height: 22px; background-color: ${available ? 'green' : 'red'}; border-radius: 50%; color: white; font-weight: bold; font-size: 10px; margin-left: 15px;">i</span>
        `;
        console.log(`Disponibilità aggiornata per riga principale handle ${handle}`);
    }
    }

    // Function to update availability in the mobile main row
    function updateMobileMainRowAvailability(handle, available) {
    const mainAvailabilityCellMobile = document.querySelector(`.availability-main-mobile[data-handle="${handle}"]`);
    if (mainAvailabilityCellMobile) {
        mainAvailabilityCellMobile.innerHTML = `
        <span style="display: flex; justify-content: center; align-items: center; width: 22px; height: 22px; background-color: ${available ? 'green' : 'red'}; border-radius: 50%; color: white; font-weight: bold; font-size: 10px;">i</span>
        `;
        console.log(`Disponibilità aggiornata per riga principale mobile handle ${handle}`);
    }
    }

    // Function to update availability in the mobile expanded row
    function updateExpandedAvailabilityMobile(handle, available, quantity) {
    const expandedAvailabilityCellMobile = document.querySelector(`.availability-mobile[data-handle="${handle}"]`);
    if (expandedAvailabilityCellMobile) {
        expandedAvailabilityCellMobile.innerHTML = `
        <div style="text-align: right; margin-bottom: 10px;">
            <span style="display: inline-flex; align-items: center; background-color: ${available ? 'green' : 'red'}; border-radius: 50%; color: white; font-weight: bold; font-size: 10px; width: 18px; height: 18px; justify-content: center; margin-right: 8px;">i</span>
            <span style="font-size: 12px;">${available ? quantity + ' Disponibili' : 'Non disponibile'}</span>
        </div>
        <div style="text-align: right; font-size: 12px; color: green; cursor: pointer; line-height: 1.2em;" onclick="openMail('${handle}')">
            ${available ? 'Se desideri quantità superiori o particolari <u>clicca qui</u>' : ''}
        </div>
        `;
        console.log(`Disponibilità aggiornata per versione mobile espansa handle ${handle}`);
    }
    }
  
  // Funzione per ottenere l'handle del prodotto di riferimento
async function fetchReferenceHandle(handle) {
    const response = await fetch(`https://80d8cf-2.myshopify.com/api/2023-01/graphql.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "87660af8e936177d0da408b5058fb138"
      },
      body: JSON.stringify({
        query: `
        {
          productByHandle(handle: "${handle}") {
            metafield(namespace: "custom", key: "testlimits_reference") {
              value
            }
          }
        }
        `
      })
    });
  
    const data = await response.json();
    const metafieldValue = data.data.productByHandle?.metafield?.value;

    if (metafieldValue) {
    const parsedValue = JSON.parse(metafieldValue);
    return parsedValue.reference_product_handle;
    } else {
    // Metafield is empty or does not exist
    return null;
    }
}
  
  // Funzione per ottenere i dati `custom.testlimiti` del prodotto referenziato
async function fetchTestLimitsData(referenceHandle) {
    const response = await fetch(`https://80d8cf-2.myshopify.com/api/2023-01/graphql.json`, {
        method: "POST",
        headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": "87660af8e936177d0da408b5058fb138"
        },
        body: JSON.stringify({
        query: `
        {
            productByHandle(handle: "${referenceHandle}") {
            metafield(namespace: "custom", key: "testlimiti") {
                value
            }
            }
        }
        `
        })
    });

    const data = await response.json();
    return JSON.parse(data.data.productByHandle?.metafield?.value || "{}");
}

function hideReferenceTableSections() {
    // Hide desktop section
    const desktopSection = document.getElementById("variant-table-section-reference");
    if (desktopSection) {
      desktopSection.style.display = "none";
    }
  
    // Hide mobile section
    const mobileSection = document.getElementById("variant-table-section-reference-mobile");
    if (mobileSection) {
      mobileSection.style.display = "none";
    }
  
    // Optionally, hide the heading if it's separate
    const heading = document.getElementById("reference-table-heading");
    if (heading) {
      heading.style.display = "none";
    }
  
    // Optionally, hide the reset filters button
    const resetButton = document.getElementById("reset-filters-button");
    if (resetButton) {
      resetButton.style.display = "none";
    }
  }
  

// Function to open mail with prefilled subject and body
function openMail(handle, sku) {
    const mailtoLink = `mailto:info@renaudo.com?subject=Richiesta disponibilità&body=Prodotto SKU: ${sku}%0AHandle: ${handle}%0AQuantità richiesta: [specifica qui la quantità desiderata]`;
    window.location.href = mailtoLink;
  }

// Function to reset table filters
function resetFilters() {
    console.log("Esecuzione di resetFilters");
    // Reload the page to reset filters
    window.location.reload();
  }
   
// Define toggleExpand for the desktop version
function toggleExpand(rowIndex) {
    event.stopPropagation();
    const rowToExpand = document.getElementById(`expandable-row-${rowIndex}`);
    if (rowToExpand) {
      if (rowToExpand.style.display === "table-row") {
        rowToExpand.style.display = "none";
      } else {
        // Hide all expanded rows first
        document.querySelectorAll(".expandable-row").forEach(row => {
          row.style.display = "none";
        });
        // Show the selected row
        rowToExpand.style.display = "table-row";
      }
    } else {
      console.warn(`Row with ID expandable-row-${rowIndex} not found.`);
    }
  }

  
    // Function to add item to cart
    async function addToCart(variantId, quantity, button) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity
          })
        });
  
        if (response.ok) {
          console.log(`Articolo con Variant ID ${variantId} aggiunto al carrello con quantità ${quantity}`);
          showConfirmationMessage(button, true); // Show success message
          // Optionally update cart count if you have such a function
          // updateCartCount();
        } else {
          const errorData = await response.json();
          console.error("Errore nell'aggiunta al carrello:", errorData.description);
          showConfirmationMessage(button, false); // Show "Non disponibile" for stock issues
        }
      } catch (error) {
        console.error("Errore durante la richiesta di aggiunta al carrello:", error);
        showConfirmationMessage(button, false); // Show "Non disponibile" for network or server issues
      }
    }
  
    // Function to show confirmation message under the button
    function showConfirmationMessage(button, isAvailable) {
      const messageDiv = document.createElement("div");
      messageDiv.textContent = isAvailable ? "Articolo aggiunto al carrello" : "Non disponibile";
  
      messageDiv.style.cssText = `
        position: absolute;
        background-color: ${isAvailable ? '#28a745' : '#dc3545'};
        color: white;
        padding: 6px 12px;
        border-radius: 4px;
        font-size: 8px;
        font-weight: 500;
        text-align: center;
        white-space: nowrap;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 1000;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
        opacity: 0;
        transition: opacity 0.4s ease;
      `;
  
      button.parentNode.style.position = "relative";
      button.parentNode.appendChild(messageDiv);
  
      setTimeout(() => { messageDiv.style.opacity = 1; }, 10);
  
      setTimeout(() => {
        messageDiv.style.opacity = 0;
        setTimeout(() => messageDiv.remove(), 500);
      }, 3000);
    }
  
    // Event listeners for desktop Add-to-Cart buttons
    document.querySelectorAll(".add-to-cart").forEach(button => {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        const variantId = button.getAttribute("data-variant-id");
        const quantityInput = button.closest("tr").querySelector("input[type='number']");
  
        if (quantityInput) {
          const quantity = parseInt(quantityInput.value);
          addToCart(variantId, quantity, button); // Pass button to show message under it
        } else {
          console.error("Elemento input quantità non trovato.");
        }
      });
    });
  
    // Event listeners for mobile Add-to-Cart buttons
    document.querySelectorAll(".mobile-add-to-cart").forEach(button => {
      button.addEventListener("click", function (event) {
        event.stopPropagation();
        const variantId = button.getAttribute("data-variant-id");
  
        // Find the closest mobile variant container
        const mobileVariantContainer = button.closest(".mobile-variant");
  
        if (mobileVariantContainer) {
          // Within the container, find the quantity input
          const quantityInput = mobileVariantContainer.querySelector('input[id^="mobile-quantity"]');
  
          if (quantityInput) {
            const quantity = parseInt(quantityInput.value);
            addToCart(variantId, quantity, button);
          } else {
            console.error("Elemento input quantità non trovato.");
          }
        } else {
          console.error("Div con class 'mobile-variant' non trovato.");
        }
      });
    });
  
    function attachAddToCartEventListeners() {
        // Event listeners for desktop Add-to-Cart buttons
        document.querySelectorAll(".add-to-cart").forEach(button => {
          button.addEventListener("click", function (event) {
            event.stopPropagation();
            const variantId = button.getAttribute("data-variant-id");
            const quantityInput = button.closest("tr").querySelector("input[type='number']");
      
            if (quantityInput) {
              const quantity = parseInt(quantityInput.value);
              addToCart(variantId, quantity, button);
            } else {
              console.error("Elemento input quantità non trovato.");
            }
          });
        });
      
        // Event listeners for mobile Add-to-Cart buttons
        document.querySelectorAll(".mobile-add-to-cart").forEach(button => {
          button.addEventListener("click", function (event) {
            event.stopPropagation();
            const variantId = button.getAttribute("data-variant-id");
      
            // Find the closest mobile variant container
            const mobileVariantContainer = button.closest(".mobile-variant");
      
            if (mobileVariantContainer) {
              // Within the container, find the quantity input
              const quantityInput = mobileVariantContainer.querySelector('input[id^="mobile-quantity"]');
      
              if (quantityInput) {
                const quantity = parseInt(quantityInput.value);
                addToCart(variantId, quantity, button);
              } else {
                console.error("Elemento input quantità non trovato.");
              }
            } else {
              console.error("Div con class 'mobile-variant' non trovato.");
            }
          });
        });
      }
      
  
// Funzione per copiare il codice sconto e mostrare il messaggio di conferma
function copyDiscountCode1(code, button) {
  // Copia il codice negli appunti
  navigator.clipboard.writeText(code).then(() => {
    console.log(`Codice sconto ${code} copiato negli appunti`);
    showCopyConfirmationMessage(button, true); // Mostra messaggio di successo
  }).catch(err => {
    console.error('Errore durante la copia del codice sconto:', err);
    showCopyConfirmationMessage(button, false); // Mostra messaggio di errore
  });
}

// Funzione per mostrare il messaggio di conferma sotto il pulsante
function showCopyConfirmationMessage(button, isSuccess) {
  const messageDiv = document.createElement("div");
  messageDiv.textContent = isSuccess ? "Codice sconto copiato!" : "Errore nella copia";

  messageDiv.style.cssText = `
    position: absolute;
    background-color: ${isSuccess ? '#28a745' : '#dc3545'};
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    top: -35px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    opacity: 0;
    transition: opacity 0.4s ease;
  `;

  button.parentNode.style.position = "relative";
  button.parentNode.appendChild(messageDiv);

  setTimeout(() => { messageDiv.style.opacity = 1; }, 10);

  setTimeout(() => {
    messageDiv.style.opacity = 0;
    setTimeout(() => messageDiv.remove(), 500);
  }, 3000);
}



function attachFilterEventListeners() {
        // Attach 'change' event to desktop filters
        document.querySelectorAll(".filter-select").forEach(select => {
          select.addEventListener("change", function (event) {
            event.preventDefault();
      
            setTimeout(() => {
              console.log("Filtro cambiato:", select.getAttribute("data-column"), select.value);
              applyFilter(); // Call the filter function
            }, 100); // Delay to ensure the filter value is registered
          });
        });
      }
      
      function applyFilter() {
        const filters = {};
      
        // Collect selected filter values
        document.querySelectorAll(".filter-select").forEach(select => {
          const column = select.getAttribute("data-column");
          const value = select.value.trim().toLowerCase();
          if (value !== "all") {
            filters[column] = value;
          }
        });
      
        console.log("Filtri attivi:", filters);
        let rowsVisible = false;
      
        // Iterate over each table row to apply filters
        document.querySelectorAll("#desktop-table-body tr.clickable-row").forEach(row => {
          let isVisible = true;
      
          // Apply filters to the current row
          for (const column in filters) {
            const cell = row.querySelector(`td[data-column="${column}"]`);
            const cellValue = cell ? cell.textContent.trim().toLowerCase() : '';
      
            console.log(`Colonna: ${column}, Valore cella: ${cellValue}, Filtro: ${filters[column]}`);
      
            if (filters[column] && cellValue !== filters[column]) {
              isVisible = false;
              break;
            }
          }
      
          // Show or hide the row based on the filter result
          row.style.display = isVisible ? "" : "none";
      
          // Hide the expanded row if its main row is hidden
          const expandedRow = document.getElementById(`expandable-row-${row.getAttribute('data-index')}`);
          if (expandedRow) {
            expandedRow.style.display = isVisible ? expandedRow.style.display : "none";
          }
      
          if (isVisible) {
            rowsVisible = true;
          }
        });
      
        // Show or hide the "No Results" message
        const noResultsRow = document.getElementById("no-results-row");
        if (noResultsRow) {
          noResultsRow.style.display = rowsVisible ? "none" : "table-row";
        }
      }

      


      function attachFilterEventListenersMobile() {
        // Attach 'change' event to mobile filters
        document.querySelectorAll(".mobile-filter").forEach(select => {
          select.addEventListener("change", function (event) {
            event.preventDefault();
      
            setTimeout(() => {
              console.log("Filtro cambiato (mobile):", select.getAttribute("data-column"), select.value);
              applyFilterMobile(); // Call the mobile filter function
            }, 100);
          });
        });
      }
      
      function applyFilterMobile() {
        const filters = {};
      
        // Collect selected filter values for mobile
        document.querySelectorAll(".mobile-filter").forEach(select => {
          const column = select.getAttribute("data-column");
          const value = select.value.trim().toLowerCase();
          if (value !== "all") {
            filters[column] = value;
          }
        });
      
        console.log("Filtri attivi (mobile):", filters);
        let rowsVisibleMobile = false;
      
        // Apply filters to mobile variants
        document.querySelectorAll("#mobile-variant-container .mobile-variant").forEach(variant => {
          let isVisible = true;
      
          for (const column in filters) {
            const cell = variant.querySelector(`div[data-column="${column}"]`);
            const cellValue = cell ? cell.getAttribute("data-value").toLowerCase() : '';
      
            if (filters[column] && cellValue !== filters[column]) {
              isVisible = false;
              break;
            }
          }
      
          // Show or hide the variant based on filters
          variant.style.display = isVisible ? "block" : "none";
      
          if (isVisible) {
            rowsVisibleMobile = true;
          }
        });
      
        // Show or hide the "No Results" message for mobile
        const noResultsRowMobile = document.getElementById("no-results-row-mobile");
        if (noResultsRowMobile) {
          noResultsRowMobile.style.display = rowsVisibleMobile ? "none" : "block";
        }
      }

      



  // Define toggleExpandMobile for the mobile version
  function toggleExpandMobile(rowIndex) {
    event.stopPropagation();
    const rowToExpand = document.getElementById(`expandable-row-mobile-${rowIndex}`);
    if (rowToExpand) {
      if (rowToExpand.style.display === "block") {
        rowToExpand.style.display = "none";
      } else {
        // Hide all expanded rows first
        document.querySelectorAll(".expanded-content-mobile").forEach(row => {
          row.style.display = "none";
        });
        // Show the selected row
        rowToExpand.style.display = "block";
      }
    } else {
      console.warn(`Row with ID expandable-row-mobile-${rowIndex} not found.`);
    }
  }

function changeQuantity(action, index, isMobile = false) {
  const inputId = isMobile ? `mobile-quantity-${index}` : `quantity-${index}`;
  const quantityInput = document.getElementById(inputId);
  let quantity = parseInt(quantityInput.value);

  if (action === 'increase') {
    quantity += 1;
  } else if (action === 'decrease' && quantity > 1) {
    quantity -= 1;
  }

  quantityInput.value = quantity;
}

  

  
function renderReferenceTable(data, containerId) {
  console.log("Render tabella Desktop");
  let tableHTML = `<div class="table-wrapper">
      <div class="variant-table-container">
        <table class="variant-table">
          <thead>
            <tr class="table-header-row">`;

          // Nuova colonna "Immagine"
        tableHTML += `<th class="table-header-cell">Image</th>`;

  // Colonne della tabella
  data.columns.forEach(column => {
    const truncatedColumn = column.length > 15 ? column.slice(0, 15) + "..." : column;
    const columnTitle = column.length > 15 ? `title="${column}"` : ''; // Add title if truncated
    tableHTML += `<th class="table-header-cell">
      <select class="filter-select" data-column="${column}" ${columnTitle}>
        <option value="all">${truncatedColumn}</option>
        ${[...new Set(data.rows.map(row => row.table[data.columns.indexOf(column)]))].sort().map(value => {
          const truncatedValue = value.length > 20 ? value.slice(0, 20) + "..." : value;
          const optionTitle = value.length > 20 ? `title="${value}"` : ''; // Add title if truncated
          return `
            <option value="${value}" ${optionTitle}>${truncatedValue}</option>
          `;
        }).join('')}
      </select>
    </th>`;
  });

  // Add 'Prezzo' column header before 'Quantità'
  tableHTML += `<th class="table-header-cell">Prezzo</th>
    <th class="table-header-cell">Quantità</th>
    <th class="table-header-cell">Info</th>
    <th class="table-header-cell">Carrello</th>
    </tr>
    </thead>
    <tbody id="desktop-table-body">`; // Add an ID to the tbody

  // Righe della tabella
  data.rows.forEach((row, index) => {
    tableHTML += `<tr class="clickable-row" onclick="toggleExpand(${index})" style="max-width: 100%; table-layout: auto;">`;

        // Aggiungi la cella dell'immagine come prima cella solo se esiste
    if (row.form.product_image) {
      // Se c'è un'immagine, la mostriamo
      tableHTML += `<td class="table-cell-ellipsis">
                    <img src="${row.form.product_image}" alt="Immagine prodotto" style="width: 50px; height: 50px; object-fit: contain; border-radius: 5px; border: 1px solid #3b3b3b;">
                   </td>`;  // Inserisce l'immagine del prodotto
    } else {
      // Se non c'è un'immagine, mostriamo un quadrato bianco
      tableHTML += `<td class="table-cell-ellipsis"><span style="width: 50px; height: 50px; background-color: white !important; border-radius: 5px; border: 1px solid #3b3b3b; display: block;"></span>
                   </td>`;  // Quadrato bianco
    }

    row.table.forEach((cell, cellIndex) => {
      const columnName = data.columns[cellIndex];
      const truncatedCell = cell.length > 20 ? cell.slice(0, 20) + "..." : cell;
      const cellTitle = cell.length > 20 ? `title="${cell}"` : ''; // Add title if truncated
      tableHTML += `<td data-column="${columnName}" class="table-cell-ellipsis" ${cellTitle}>${truncatedCell}</td>`;
    });

    // Add 'Prezzo' cell
    tableHTML += `<td style="font-weight: bold;">
      ${row.form.price}€
    </td>`;

    // Selettore di quantità e pulsante Aggiungi al carrello
    tableHTML += `<td>
      <div class="quantity-selector">
        <span class="quantity-button" onclick="event.stopPropagation(); changeQuantity('decrease', ${index})">-</span>
        <input type="number" value="1" min="1" id="quantity-${index}">
        <span class="quantity-button" onclick="event.stopPropagation(); changeQuantity('increase', ${index})">+</span>
      </div>
    </td>
    <td class="availability-main" data-handle="${row.form.handle}">Caricamento...</td>
    <td class="button-cell">
    <button class="add-to-cart red-button" data-variant-id="${row.form.product_id}"
    data-quantity-id="quantity-${index}" style="background: none; border: none; padding: 0;">
    <img src="https://cdn.shopify.com/s/files/1/0730/6552/9675/files/CarrelloRenaudoFerramenta.svg?v=1730978520" 
    alt="Aggiungi al carrello" style="width: 24px; height: 24px;">
    </button>
    </td>

    </tr>`;

    // Riga espandibile
    const totalColumns = data.columns.length + 5; // Aggiungendo 3 per le colonne extra
    tableHTML += `<tr id="expandable-row-${index}" class="expandable-row" style="display: none;">
      <td colspan="${totalColumns}" style="position: relative;">
        <div class="expandable-content-cell">

           <!-- Close button 'X' -->
          <span class="close-btn" onclick="toggleExpand(${index}); event.stopPropagation();">&#10005;</span>

          <!-- Prima riga -->
          <div style="display: flex; justify-content: space-between; align-items: flex-start;">

            <!-- Immagine prodotto (25%) -->
            <div style="width: 25%; text-align: left; margin-right: 30px;">
              <img src="${row.form.product_image}" 
                style="width: 100%; object-fit: contain; border-radius: 10px;">
            </div>

            <!-- Informazioni prodotto (35%) -->
            <div style="width: 35%; text-align: left; margin-right: 30px;">
              <!-- Titolo del prodotto -->
              <h3 style="margin: 0;">${row.form.titolo}</h3>

              <!-- SKU -->
              <p>Codice articolo: ${row.form.sku}</p>

              <!-- Disponibilità nella sezione espansa -->
              <div class="availability-expanded" data-handle="${row.form.handle}"
                style="margin-top: 5px; line-height: 1.2; margin-bottom: 10px;">
                <span
                  style="display: flex; width: 20px; height: 20px; background-color: gray; border-radius: 50%; justify-content: center; align-items: center; color: white; font-weight: bold;">i</span>
                <span style="font-size: 18px; margin-left: 8px;">Caricamento...</span><br>
                <span style="font-size: 12px; color: red; cursor: pointer;"
                  onclick="openMail('${row.form.handle}', '${row.form.sku}')">
                  Se desideri quantità superiori o particolari <u>clicca qui</u>
                </span>
              </div>

              <!-- Categorie -->
              <p style="margin: 5px 0;">
                <a href="${row.form.categories[0].url}"
                  style="color: #000; text-decoration: none; text-transform: uppercase; font-weight: bold;">
                  ${row.form.categories[0].value}</a>
                /
                <a href="${row.form.categories[1].url}"
                  style="color: #000; text-decoration: none; text-transform: uppercase; font-weight: bold;">
                  ${row.form.categories[1].value}</a>
              </p>

              <!-- Descrizione (troncata dopo 20 parole) -->
              <p>
              ${row.form.descrizione.split(' ').slice(0, 20).join(' ')}...
              <a href="https://renaudo.com/products/${row.form.handle}" style="color: red !important; text-decoration: none;">Read more</a>
              </p>

              <!-- Pulsante Vai al prodotto -->
              <button
                style="display: block; margin-top: 10px; padding: 10px 20px; background-color: red; color: white; border: none; cursor: pointer;"
                onclick="window.open('https://renaudo.com/products/${row.form.handle}', '_blank')">
                Vai al prodotto
              </button>
            </div>

            <!-- Dettagli dei prezzi (30%) -->
            <div style="width: 30%; text-align: left; position: relative; padding-left: 30px;">
              <!-- Linea verticale a sinistra -->
              <div style="border-left: 1px solid red; height: 200px; position: absolute; left: 0; top: 5px;"></div>

              <!-- Prezzo unitario -->
              <p style="margin-left: 10px; font-size: 14px;">Prezzo unità: <span style="color: black;">
                ${row.form.price}€</span></p>

              <!-- Tabella Sconti per Volume -->
              <table style="width: 90%; border-collapse: collapse; margin-left: 10px;">
              <thead>
                <tr>
                  <th style="border-bottom: 1px solid #ddd; padding: 4px; background-color: #f5f5f5; font-size: 12px;">
                    Quantità
                  </th>
                  <th style="border-bottom: 1px solid #ddd; padding: 4px; background-color: #f5f5f5; font-size: 12px;">
                    Sconto %
                  </th>
                </tr>
              </thead>
              <tbody>`;

              // Loop attraverso ogni sconto in volume_discounts e calcola la percentuale di sconto
              row.form.volume_discounts.forEach(discount => {
              // Normalizza 'discount.sconto' sostituendo la virgola con il punto e rimuovendo '€' e 'unità'
              let scontoValue = discount.sconto.replace(',', '.').replace('€', '').replace('unità', '').trim();
              // Estrai la parte numerica prima di eventuali spazi
              scontoValue = scontoValue.split(' ')[0];

              // Converti i valori in numeri
              const originalPrice = parseFloat(row.form.price);
              const discountedPrice = parseFloat(scontoValue);

              if (!isNaN(originalPrice) && !isNaN(discountedPrice)) {
              // Calcola la percentuale di sconto
              const discountRatio = ((discountedPrice / originalPrice) * 100) - 100;
              const absoluteDiscountPercent = Math.abs(discountRatio);
              const finalDiscountPercent = Math.round(absoluteDiscountPercent);

              // Aggiungi ogni riga alla tabella con lo sconto calcolato
              tableHTML += `
              <tr>
              <td style="border-bottom: 1px solid #ddd; padding: 4px; font-size: 12px;">${discount.scaglione}</td>
              <td style="border-bottom: 1px solid #ddd; padding: 4px; font-size: 12px; color: green; font-weight: bold;">
              -${finalDiscountPercent}%
              </td>
              </tr>`;
              } else {
              console.warn("Valore di prezzo o sconto non valido:", originalPrice, discountedPrice);
              }
              });

      tableHTML += `</tbody>
              </table>

              <!-- Sezione Codice Sconto e Pulsante Copia -->
              <div style="margin-left: 10px; margin-top: 12px;">
                <p style="color: black; font-weight: bold; font-size: 14px; line-height:1.2em;">Clicca copia e inserisci questo codice sconto in fase di checkout per usufruire dell'offerta:</p>
                <button onclick="copyDiscountCode1('SQ${row.form.sku}', this)" style="padding: 10px 20px; background-color: #4CAF50; color: white; border: none; border-radius: 4px; cursor: pointer; font-size: 12px;">
                  Copia Codice Sconto: SQ${row.form.sku}
                </button>
              </div>

            </div>
          </div>

          <!-- Seconda riga (Immagine tecnica e Tabella attributi) -->
          <div style="display: flex; justify-content: space-between; margin-top: 20px;">

            <!-- Sezione PDF (25%) -->
            <div style="width: 25%; text-align: left; position: relative; padding-left: 30px;">
              <!-- Linea verticale a sinistra -->
              <div style="border-left: 1px solid red; height: 100px; position: absolute; left: 0; top: 5px;"></div>

              <!-- Contenuto della sezione PDF -->
              <h4 style="font-size: 18px; margin-left: 10px;">Documenti</h4>
              ${row.form.pdfs && row.form.pdfs.length > 0 ? row.form.pdfs.map(pdf => `
                <a href="${pdf.url}" target="_blank"
                  style="color: black; font-size: 14px; text-decoration: none !important; font-weight: normal;">
                  <img src="https://cdn.shopify.com/s/files/1/0905/7881/3266/files/Progetto_senza_titolo_2.svg?v=1729630308"
                    style="width: 18px; height: 16px; margin-right: 5px;">
                  ${pdf.name}
                </a><br>
              `).join('') : '<p style="margin-left: 10px;">Nessun PDF disponibile</p>'}
            </div>

            <!-- Tabella Attributi (35%) -->
            <div style="width: 35%; text-align: left; padding-right: 20px;">
              <table style="width: 100%; border-collapse: collapse;">
                ${row.form.attributes.map(attribute => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 4px; background-color: #f5f5f5; width: 60%;">
                      ${attribute.name}:</td>
                    <td style="border: 1px solid #ddd; padding: 4px; background-color: #f5f5f5; width: 40%;">
                      ${attribute.value}</td>
                  </tr>
                `).join('')}
              </table>
            </div>

            <!-- Immagine Tecnica (30%) -->
            <div style="width: 30%; text-align: left;">
              <img src="${row.form.technical_image}" 
                style="width: 100%; object-fit: contain; border-radius: 10px;">
            </div>

          </div>

        </div>
      </td>
    </tr>`;
  });

  // Aggiungi una riga "Nessun risultato"
  const totalColumns = data.columns.length + 3; // Aggiungendo 3 per le colonne extra
  tableHTML += `
  <tr id="no-results-row" style="display: none;">
      <td colspan="${totalColumns}" style="text-align: center; padding: 20px;">
      Nessun prodotto disponibile con i filtri selezionati
      </td>
  </tr>
  `;

  tableHTML += `</tbody>
      </table>
      </div>
  </div>`;

  document.getElementById(containerId).innerHTML = tableHTML;
}

  
  
  
  
  
// Funzione per rendere la tabella mobile
function renderReferenceTableMobile(data, containerId) {
  console.log("Render tabella mobile");
  let tableHTML = `<div class="filter-container">`;

  // Genera i filtri delle colonne per mobile
  data.columns.forEach(column => {
    const truncatedColumn = column.length > 20 ? column.slice(0, 20) + "..." : column;
    tableHTML += `<select class="mobile-filter" data-column="${column}">
                    <option value="all">${truncatedColumn}</option>
                    ${[...new Set(data.rows.map(row => row.table[data.columns.indexOf(column)]))].sort().map(value => `
                      <option value="${value}">${value}</option>
                    `).join('')}
                  </select>`;
  });

  tableHTML += `</div><div class="mobile-variant-container" id="mobile-variant-container">`;

  // Renderizza ogni variante per mobile
  data.rows.forEach((row, index) => {
    tableHTML += `
    <div class="mobile-variant clickable-block" data-row-index="${index}" onclick="toggleExpandMobile(${index})" style="border: 0px solid #ccc; border-radius: 5px; margin-bottom: 25px; padding: 20px; background-color: #f5f5f5; position: relative;">
      <div style="display: flex; justify-content: space-between; align-items: flex-start; font-size: 15px; line-height: 1.4em; margin-right: 10px;">
        <!-- Sezione Attributi -->
        <div style="width: 60%; font-size: 14px; line-height: 1.4em;">
        ${data.columns.map((column, columnIndex) => `
          <div data-column="${column}" data-value="${row.table[columnIndex]}" style="margin-bottom: 8px;">
            <strong>${column}</strong><br>
            ${row.table[columnIndex]}
          </div>
        `).join('')}
        </div>
        <!-- Sezione Prezzo e Disponibilità -->
        <div style="width: 40%; text-align: right;">
          <strong>Prezzo:</strong> ${row.form.price}€
          <!-- Disponibilità nella riga principale mobile -->
          <div class="availability-main-mobile" data-handle="${row.form.handle}" style="display: flex; justify-content: flex-end; align-items: center; margin-top: 5px;">Caricamento...</div>
          
          <!-- Informazioni sugli Sconti Mobile -->
${row.form.volume_discounts && row.form.volume_discounts.length > 0 ? `
<div style="width: 100%; margin-top: 10px;">
  ${row.form.volume_discounts.map(discount => {
    // Normalizza 'discount.sconto'
    let scontoValue = discount.sconto.replace(',', '.').replace('€', '').replace('unità', '').trim();
    scontoValue = scontoValue.split(' ')[0];

    const originalPrice = parseFloat(row.form.price);
    const discountedPrice = parseFloat(scontoValue);

    if (!isNaN(originalPrice) && !isNaN(discountedPrice)) {
      const discountRatio = ((discountedPrice / originalPrice) * 100) - 100;
      const absoluteDiscountPercent = Math.abs(discountRatio);
      const finalDiscountPercent = Math.round(absoluteDiscountPercent);

      return `
        <div style="padding: 0px; line-height: 1.2em; font-size: 14px; margin-bottom: 10px;">
          Acquista <span style="color: green;">${discount.scaglione}</span> per risparmiare <span style="color: green;">-${finalDiscountPercent}%</span>
        </div>
      `;
    } else {
      console.warn("Valore di prezzo o sconto non valido:", originalPrice, discountedPrice);
      return '';
    }
  }).join('')}

            <!-- Sezione Codice Sconto e Pulsante Copia -->
            <div style="padding: 0px; line-height: 1.2em; font-size: 14px; margin-bottom: 7px; text-align: right;">
              <span style="color: green; font-weight: bold; cursor: pointer;" onclick="event.stopPropagation(); copyDiscountCode2('SQ${row.form.sku}', this)">
                Copia codice sconto: SQ${row.form.sku}
              </span>
            </div>

            <div style="margin-top: 12px;">
              <span style="text-decoration: underline; font-weight: bold; cursor: pointer; font-size: 12px;">
                INFO
              </span>
            </div>
          </div>
          ` : ''}
          
          <!-- Selettore di quantità e Pulsante Aggiungi al Carrello -->
          <div style="margin-top: 30px; display: flex; flex-direction: column; align-items: flex-end;">
            <div class="quantity-selector" style="display: flex; align-items: center; margin-bottom: 2px; margin-left: 2px;">
              <span class="quantity-button" onclick="event.stopPropagation(); changeQuantity('decrease', ${index}, true)" style="padding: 8px; font-size: 16px; border-radius: 4px; cursor: pointer;">-</span>
              <input type="number" id="mobile-quantity-${index}" value="1" min="1" style="width: 40px; height: 40px; text-align: center; border: 1px solid #ccc; border-radius: 4px; margin: 0 4px;">
              <span class="quantity-button" onclick="event.stopPropagation(); changeQuantity('increase', ${index}, true)" style="padding: 8px; font-size: 16px; border-radius: 4px; cursor: pointer;">+</span>
            </div>
            <button class="mobile-add-to-cart add-to-cart" data-variant-id="${row.form.product_id}" data-quantity-id="mobile-quantity-${index}" onclick="event.stopPropagation();" style="display: flex; align-items: center; justify-content: center; background-color: red; color: white; padding: 6px 8px; border: none; border-radius: 4px; cursor: pointer; min-width: 120px; height: 36px; margin-top: 5px; margin: 0px !important;">
              Aggiungi
            </button>
          </div>
        </div>
      </div>

      <!-- Contenuto Espanso (Nascosto di default) -->
      <div id="expandable-row-mobile-${index}" class="expanded-content-mobile" style="display: none;">

         <!-- Close button 'X' -->
        <span class="close-btn-mobile" onclick="toggleExpandMobile(${index}); event.stopPropagation();">&#10005;</span>

        <div style="display: flex; flex-wrap: wrap;">
          <!-- Immagine del Prodotto -->
          <div style="flex-basis: 40%; margin-right: 10px;">
            <img src="${row.form.product_image}" style="width: 100%; border-radius: 8px;">
          </div>

          <!-- Informazioni del Prodotto -->
          <div style="flex-basis: 55%; font-size: 15px !important;">
            <h4>${row.form.titolo}</h4>
            <p style="font-size: 12px;">Codice articolo: ${row.form.sku}</p>
            <!-- Disponibilità nella riga espansa mobile -->
            <p class="availability-mobile" data-handle="${row.form.handle}" style="text-align: right; margin-top: 5px; line-height: 1.2; margin-bottom: 30px;">
              Caricamento...
            </p>
            <!-- Categorie -->
            <p style="font-size: 15px; line-height: 1.2em;">
              <strong>Categoria:</strong>
              <a href="${row.form.categories[0].url}">${row.form.categories[0].value}</a> /
              <a href="${row.form.categories[1].url}">${row.form.categories[1].value}</a>
            </p>
            <!-- Documenti PDF -->
            <div style="width: 100%; margin-top: 10px;">
              <h4>Documenti</h4>
              ${row.form.pdfs && row.form.pdfs.length > 0 ? row.form.pdfs.map(pdf => `
                <a href="${pdf.url}" target="_blank" style="color: black; text-decoration: none; display: flex; align-items: center; margin-bottom: 3px;">
                  <img src="https://cdn.shopify.com/s/files/1/0905/7881/3266/files/Progetto_senza_titolo_2.svg?v=1729630308" style="width: 16px; height: 16px; margin-right: 5px;">
                  ${pdf.name}
                </a>
              `).join('') : '<p style="margin: 0;">Nessun PDF disponibile</p>'}
            </div>
          </div>

          <!-- Pulsante Vai al Prodotto -->
          <p style="text-align: center; margin-top: 15px; width: 100%;">
            <button style="display: block; padding: 10px 20px; background-color: red; color: white; border: none; cursor: pointer;" onclick="window.open('${row.form.url}', '_blank')">
              Vai al prodotto
            </button>
          </p>

          <!-- Immagine Tecnica e Tabella Attributi -->
          <div style="display: flex; flex-direction: column; width: 100%; margin-top: 10px;">
            <!-- Immagine Tecnica -->
            <div style="width: 100%; margin-bottom: 10px;">
              <img src="${row.form.technical_image}" style="width: 100%; border-radius: 8px;">
            </div>
            <!-- Tabella Attributi -->
            <div style="width: 100%; padding-right: 10px;">
              <h4>Specifiche tecniche</h4>
              <table>
                ${row.form.attributes.map(attribute => `
                  <tr>
                    <td>${attribute.name}:</td>
                    <td>${attribute.value}</td>
                  </tr>
                `).join('')}
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>`;
  });

  // Aggiungi un messaggio "Nessun risultato"
  tableHTML += `
  <div id="no-results-row-mobile" style="display: none; text-align: center; padding: 20px;">
    Nessun prodotto disponibile con i filtri selezionati
  </div>
  `;

  tableHTML += `</div>`;

  document.getElementById(containerId).innerHTML = tableHTML;
}



// Funzione per copiare il codice sconto e mostrare il messaggio di conferma
function copyDiscountCode2(code, element) {
  // Copia il codice negli appunti
  navigator.clipboard.writeText(code).then(() => {
    console.log(`Codice sconto ${code} copiato negli appunti`);
    showCopyConfirmationMessageMobile(element, true); // Mostra messaggio di successo
  }).catch(err => {
    console.error('Errore durante la copia del codice sconto:', err);
    showCopyConfirmationMessageMobile(element, false); // Mostra messaggio di errore
  });
}

// Funzione per mostrare il messaggio di conferma sotto l'elemento
function showCopyConfirmationMessageMobile(element, isSuccess) {
  const messageDiv = document.createElement("div");
  messageDiv.textContent = isSuccess ? "Codice sconto copiato!" : "Errore nella copia";

  messageDiv.style.cssText = `
    position: absolute;
    background-color: ${isSuccess ? '#28a745' : '#dc3545'};
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    font-size: 8px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    top: -35px;
    right: 0;
    z-index: 1000;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.15);
    opacity: 0;
    transition: opacity 0.4s ease;
  `;

  element.parentNode.style.position = "relative";
  element.parentNode.appendChild(messageDiv);

  setTimeout(() => { messageDiv.style.opacity = 1; }, 10);

  setTimeout(() => {
    messageDiv.style.opacity = 0;
    setTimeout(() => messageDiv.remove(), 500);
  }, 3000);
}


  
  
  